module.exports = __webpack_public_path__ + "static/media/Family.b89c0d48.svg";